import React from "react";
import WelcomeBack from "./WelcomeBack";
import Action from "./Action";
import RecentResults from "./RecentResults";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import { useAuth } from "../api/authUtils/AuthContext";

export default function Dashboard() {
  const { isDesktop } = useResponsiveFlags();
  const { user } = useAuth();
  return (
    <>
      <div
        style={{
          marginLeft: isDesktop ? "300px" : "0",
          padding: isDesktop ? "21px 37px" : "17px",
          paddingTop: isDesktop ? "21px" : "118px",
        }}
      >
        {user && (
          <>
            <WelcomeBack data={user} />
            <Action />
            <RecentResults data={user} />
          </>
        )}
      </div>
    </>
  );
}
